import { useMemo } from 'react';
import { getUserProfileCall } from '../../core/state/api';
import { PLATFORM_TYPE_FROM_ROLE, PlatformType } from '../constants';

/**
 * Custom hook to check the current platform type (Admin or Learning).
 *
 * @returns {Object}  `{ isAdmin, isLearning }`
 * - `isAdmin`: A boolean indicating if the current platform is in Admin mode.
 * - `isLearning`: A boolean indicating if the current platform is in Learning mode.
 */
export const usePlatform = () => {
  const { userRole } = getUserProfileCall.hook();
  const isAdmin = useMemo(
    () => !!userRole && PLATFORM_TYPE_FROM_ROLE[userRole] === PlatformType.ADMIN,
    [userRole],
  );
  const isLearning = useMemo(
    () => !!userRole && PLATFORM_TYPE_FROM_ROLE[userRole] === PlatformType.LEARNING,
    [userRole],
  );
  return { isAdmin, isLearning };
};
